import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Inject, Input,
  OnInit, Output,
} from '@angular/core';
import {AgentInventorySetting, AgentInventoryConfigModel} from '../../models/inventory-setting.model';

require('./agent-inventory-settings-table.scss');
@Component({
  standalone: false,
  selector: 'app-agent-inventory-settings-table',
  templateUrl: './agent-inventory-settings-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentInventorySettingsTableComponent implements OnInit {

  @Input() agentInventoryConfig: AgentInventoryConfigModel;
  @Output() onEdit = new EventEmitter<{setting: AgentInventorySetting, index: number}>();
  @Output() onRemove = new EventEmitter<{index: number}>();

  constructor() {
  }

  ngOnInit() {

  }

}
